<h2>How To Play in 60 Seconds (Basic Gameplay)</h2>
<iframe width="560" height="315" src="https://www.youtube.com/embed/jEo1kvtOkcg?controls=0&start=18" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>

<h2>Full Rules:</h2>
<p>
  Each player will start off with FIVE 6-sided dice that get randomized between each round.
</p>

<p>
  Players will take turns submitting a dice combination that they thing are available between ALL players (aka "the board").
  <br>
  Ex: There are 4 players with 20 dice total, you submit a dice combination that you think exists within the 20 die. Such as 4 - 2's.
</p>

<p>
  If you are a user that is not submitting, at any time you are allowed to challenge what the most recent dice submission is.
  <br>
  Ex: If there are 10 dice left between all players, and one user submitted a combination of "8 - 5's", and you do not think that there are
  at least eight 5's available, then you may want to challenge.
</p>

<p>
  <strong>BE CAREFUL!</strong> If you decide to challenge and there are AT LEAST eight 5's available, then you will lose one of you die, however, if your challenge is correct, then the player who submitted the incorrect dice combination will lose a dice.
</p>

<p>
  <strong>PLOT TWIST:</strong> 1's count as wild dice and are included in any dice combination count.
  <br>
  Ex: If there are 3 dice available and a player submits 2 - 3's and there is only one 3 on the board but there is also a 1 on the board, then 2 - 3's is a valid submission.
</p>

<p>The more dice you have, the better chance you will have of winning the game.</p>

<p>The winner of the game will be the last player standing after all other users lose all of their dice.</p>

<h3>END GAME:</h3>
<p>
  At the end of the game, there will be only 2 players left, a new challenge type called "EXACTO" will be available.
</p>

<p>
  If a player submits a dice combination, you can still challenge if you think that their dice combination is wrong, or you can do an EXACTO challenge.
  An EXACTO challenge means that you think that the dice combination your opponent submitted is exactly what is on the board.
  <br>
  Ex: If there are two users and 1 dice each, and one user submits "2 - 2's" and you think that their is exactly 2 - 2's on the board, you can do an EXACTO challenge, if there are exactly 2 - 2's then your opponent loses a dice, if there are not 2 - 2's, then you lose the dice.
</p>

<h3>Valid Dice Submission:</h3>
<p>
Each submission must increment the amount of die that the previous submission. You can leave the AMOUNT of die the same, if you increase the die face.
  <br>
  Ex: If the previous submission is "4 - 5's", then you can either increase the die amount such as "7 - 5's" or "7 - 1's" or you can keep the amount but increase the die face such as "4 - 6's".
</p>

<p>Don't worry, the game will remind you what a valid submission is so it won't slow you down when you play.</p>
